import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { localizedRelativeTime } from '../../../../utils/ats-details-utils';
import { appendSequenceNumbers } from '../../utils';
import { CallToAction } from '../call-to-action-button';
import { isLimitedToHomeNetwork } from '../utils';
import { NotAvailableCallToAction } from './not-available-call-to-action';
import { ProgramCallToActionProps } from './program-call-to-action';
import { ProgramGetAccessCallToAction } from './program-get-access';
import { RecordCallToAction } from './record-call-to-action';

export function FutureProgramCallToAction({ focusedAsset, source }: ProgramCallToActionProps) {
  const { t } = useTranslation();
  const hasPvr = useSelector((state) => state.authReducer.hasPvr);

  if (!hasPvr) {
    return (
      <CallToAction
        text={{
          primary: appendSequenceNumbers(t('details:only-live'), focusedAsset),
          secondary: localizedRelativeTime(source.startTime, 'airtime'),
        }}
        image={{
          src: source.image,
          alt: source.name,
        }}
        disabled
      />
    );
  }

  if (!source.isSubscribed) {
    return <ProgramGetAccessCallToAction source={source} />;
  }

  if (isLimitedToHomeNetwork(source)) {
    return <NotAvailableCallToAction source={source} />;
  }

  return <RecordCallToAction focusedAsset={focusedAsset} source={source} />;
}
